import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/getList',
        method: 'get',
        params: {
            ...params,
            current,
            size
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/removeProduct/' + ids,
        method: 'get'
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/submit',
        method: 'post',
        data: row
    })
}